import PropTypes from "prop-types";
import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import MetaTags from "react-meta-tags";
import Paginator from "react-hooks-paginator";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { connect } from "react-redux";
import { getSortedProducts } from "../../helpers/product";
import LayoutOne from "../../layouts/LayoutOne";
import HTMLFlipBook from "react-pageflip";
import { Link } from "react-router-dom";
import Magnifier from "react-magnifier";
import { useParams } from "react-router-dom";

const CatalogFlip = ({ location, products, page }) => {
  const [layout, setLayout] = useState("grid three-column");
  const [sortType, setSortType] = useState("");
  const [sortValue, setSortValue] = useState("");
  const [filterSortType, setFilterSortType] = useState("");
  const [filterSortValue, setFilterSortValue] = useState("");
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totPages, setTotPages] = useState(1000);
  //const [currentData, setCurrentData] = useState([]);
  const [sortedProducts, setSortedProducts] = useState([]);
  const pageLimit = 15;
  const { pathname } = location;
  const book = useRef();
  const touchStart = useRef({ x: 0, y: 0 });
  const routeParams = useParams();
  useEffect(() => {
    console.log(book);
  }, [currentPage]);
  const getLayout = (layout) => {
    setLayout(layout);
  };

  const getSortParams = (sortType, sortValue) => {
    setSortType(sortType);
    setSortValue(sortValue);
  };

  const getFilterSortParams = (sortType, sortValue) => {
    setFilterSortType(sortType);
    setFilterSortValue(sortValue);
  };

  useEffect(() => {
    let sortedProducts = getSortedProducts(products, sortType, sortValue);
    const filterSortedProducts = getSortedProducts(
      sortedProducts,
      filterSortType,
      filterSortValue
    );
    sortedProducts = filterSortedProducts;
    setSortedProducts(sortedProducts);
    //setCurrentData(sortedProducts.slice(offset, offset + pageLimit));
  }, [offset, products, sortType, sortValue, filterSortType, filterSortValue]);

  useEffect(() => {
    if (page > 0) {
      const interval = setInterval(() => {
        console.log("interval", page);
        console.log("interval", book.current.pageFlip());
        let p = 0;
        while (p <= page) {
          if (book.current.pageFlip()) {
            clearInterval(interval);
            book.current.pageFlip().flipNext();
          }
          p = p + 2;
        }
      }, 100);
    }
  }, []);
  const onKeyPressed = (e) => {
    if (book.current == null) return;
    if (e.keyCode == 37) book.current.pageFlip().flipPrev();
    if (e.keyCode == 39) book.current.pageFlip().flipNext();
  };
  useEffect(() => {
    document.addEventListener("keydown", onKeyPressed);
  }, []);
  const pagine = [...Array(226).keys()];
  var strings = require("../../translations/italian.json");

  const onFlip = useCallback((e) => {
    setCurrentPage(e.data);
    try {
      setTotPages(book.current.pageFlip().getPageCount() - 1);
    } catch (error) { }
    ////console.log('Current page: ' + e.data);
  }, []);

  var informazioni = global.informazioni;

  // GESTIONE SWIPE CUSTOM (ignora lo scroll verticale)
  const handleTouchStart = (e) => {
    touchStart.current = {
      x: e.changedTouches[0].screenX,
      y: e.changedTouches[0].screenY,
    };
  };

  const handleTouchEnd = (e) => {
    const dx = e.changedTouches[0].screenX - touchStart.current.x;
    const dy = e.changedTouches[0].screenY - touchStart.current.y;

    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
      if (!book.current || !book.current.pageFlip()) return;
      if (dx < 0) book.current.pageFlip().flipNext();
      else book.current.pageFlip().flipPrev();
    }
  };

  return (
    <Fragment>
      <MetaTags>
        <title>
          {strings.catalog} | {informazioni.società}
        </title>
        <meta
          name="description"
          content={strings.catalog + " " + informazioni.società}
        />
      </MetaTags>

      <BreadcrumbsItem to={process.env.PUBLIC_URL + "/"}>Home</BreadcrumbsItem>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>
        Shop
      </BreadcrumbsItem>

      <LayoutOne headerTop="invisible" footerTop="invisible">
        <div className="shopping-cart-btn btn-hover text-center mt-20">
          <a
            className="default-btn"
            style={{ marginBottom: "20px" }}
            href="/files/catalogoDGA.pdf"
          >
            {strings["download_catalog"]}
          </a>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "20px 0",
          }}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          {currentPage != 0 && (
            <div className="shopping-cart-btn btn-hover text-center">
              <Link
                className="default-btn"
                onClick={() => book.current.pageFlip().flipPrev()}
              >
                &lt;
              </Link>
            </div>
          )}
          <HTMLFlipBook
            ref={book}
            width={450}
            height={650}
            minWidth={315}
            maxWidth={1000}
            minHeight={400}
            maxHeight={800}
            maxShadowOpacity={0.5}
            showCover={true}
            mobileScrollSupport={true}
            className="demo-book"
            style={{ maxHeight: "75vh" }}
            onFlip={onFlip}
            useMouseEvents={false}
            useTouchEvents={false}
          >
            {pagine.map((pagine) => {
              return (
                <div className="page" key={pagine} data-density="hard">
                  <div className="page-content">
                    <div className="page-image">
                      {/*} <img
                                    className="animated img-fluid"
                                    src = {pagine.immagine}
                                    alt=""
                        /> */}
                      <Magnifier
                        src={
                          "/assets/img/catalogo/ALL/Pagina_" +
                          String(pagine).padStart(3, "0") +
                          ".jpg"
                        }
                        mgWidth={300}
                        mgHeight={300}
                        mgShape={"square"}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </HTMLFlipBook>
          {currentPage != totPages && (
            <div className="shopping-cart-btn btn-hover text-center">
              <Link
                className="default-btn"
                onClick={() => book.current.pageFlip().flipNext()}
              >
                &gt;
              </Link>
            </div>
          )}
        </div>
        <div style={{ textAlign: "center" }}>
          {currentPage == 0 && <p>Copertina</p>}
          {currentPage != 0 && (
            <p>
              Pagine {currentPage - 1}/{currentPage} di {totPages}
            </p>
          )}
        </div>
        <div className="row">
          <link
            rel="stylesheet"
            href="https://fonts.googleapis.com/icon?family=Material+Icons"
          />

          <div>
            <div
              style={{
                justifyContent: "center",
                display: "flex",
                width: "100%",
              }}
            >
              <a
                href={
                  "https://dgaplanetshirt.com/files/cataloghi/FRUIT.pdf"
                }
                target="_blank"
                style={{
                  padding: "1%",
                  border: "1px dotted black",
                  width: "15%",
                  textAlign: "center",
                }}
              //download="Cartella_colori_Fruit.xlsx"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/it/5/51/Fruit_of_the_Loom_logo.JPG"
                  style={{ width: "35%" }}
                />
              </a>{" "}
              &nbsp;
              <a
                href={"https://dgaplanetshirt.com/files/cataloghi/JHK.pdf"}
                target="_blank"
                style={{
                  padding: "1%",
                  border: "1px dotted black",
                  width: "15%",
                  textAlign: "center",
                }}
              //download="Cartella_colori_JHK.pdf"
              >
                <img
                  src="https://www.jhktshirt.com/images/logo.png"
                  style={{ width: "35%" }}
                />
              </a>{" "}
              &nbsp;
              <a
                href={
                  "https://dgaplanetshirt.com/files/cataloghi/JHK_PROFESSIONAL.pdf"
                }
                target="_blank"
                style={{
                  padding: "1%",
                  border: "1px dotted black",
                  width: "15%",
                  textAlign: "center",
                }}
              //download="Cartella_colori_Velilla.pdf"
              >
                <img
                  src="https://s3-eu-west-1.amazonaws.com/jhk-public/uploads/busquedas/e470347185dd4e6d55284b8537ba4b3b691657de.png"
                  style={{ width: "35%" }}
                />
              </a>
              &nbsp;
              <a
                href={
                  "https://dgaplanetshirt.com/files/cataloghi/RUSSELL.pdf"
                }
                target="_blank"
                style={{
                  padding: "1%",
                  border: "1px dotted black",
                  width: "15%",
                  textAlign: "center",
                }}
              //download="Cartelle_colori_Russell.pdf"
              >
                <img
                  src="https://www.images-magazine.com/wp-content/uploads/2022/01/Russell-Europe-2022-logo.jpg"
                  style={{ width: "35%" }}
                />
              </a>{" "}
              &nbsp;
              <a
                href={
                  "https://dgaplanetshirt.com/files/cataloghi/VELILLA.pdf"
                }
                target="_blank"
                style={{
                  padding: "1%",
                  border: "1px dotted black",
                  width: "15%",
                  textAlign: "center",
                }}
              //download="Cartella_colori_Velilla.pdf"
              >
                <img
                  src="https://www.tuttoperlasicurezza.it/img/m/20.jpg"
                  style={{ width: "35%" }}
                />
              </a>
              &nbsp;
              <a
                href={
                  "https://dgaplanetshirt.com/files/cataloghi/SPARCO.pdf"
                }
                target="_blank"
                style={{
                  padding: "1%",
                  border: "1px dotted black",
                  width: "15%",
                  textAlign: "center",
                }}
              //download="Cartella_colori_Velilla.pdf"
              >
                <img
                  src="https://www.sparco-official.com/SparcoLogo-ruU.svg"
                  style={{ width: "40%" }}
                />
              </a>

            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

CatalogFlip.propTypes = {
  location: PropTypes.object,
  products: PropTypes.array,
};

const mapStateToProps = (state, ownProps) => {
  const page = ownProps.match.params.page;
  return {
    products: state.productData.products,
    page,
  };
};

export default connect(mapStateToProps)(CatalogFlip);
